import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
  standalone: false
})
export class ActionButtonsComponent {
  
  @Input() buttonsList: any;
  @Output() actionClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  handleActionClick(action: string) {
    this.actionClicked.emit(action);
  }
}